/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { AbilityBuilder, Ability } from '@casl/ability';
import { ADMIN_CANNOT_ABILITY, ADMIN_CAN_ABILITY } from './admin';
import { HOLDER_CAN_ABILITY, HOLDER_CANNOT_ABILITY } from './holder';

export const defineAbilityFor = (whoami: string) => {
  const ability: any = new AbilityBuilder(Ability);
  if (whoami === 'owner') {
    ability.can('manage', 'all'); // read-write access to everything
  } else if (whoami === 'admin' || whoami === 'master admin') {
    ADMIN_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });

    ADMIN_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === 'purchaser' || whoami === 'TELLER') {
    HOLDER_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });

    HOLDER_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else {
    ability.cannot('read', 'all'); // read-only access to everything
  }

  return ability.build();
};
